import { render, staticRenderFns } from "./SavedConfigurationList.vue?vue&type=template&id=38e37a9d&scoped=true"
import script from "./SavedConfigurationList.vue?vue&type=script&lang=js"
export * from "./SavedConfigurationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e37a9d",
  null
  
)

export default component.exports